import React, { useEffect } from 'react';
import { Button, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { useAuth0Backend } from './useAuth0Backend';
import './SimpleLogin.css';

const Auth0BackendLogin = () => {
  const { user, loading, error, login, isAuthenticated } = useAuth0Backend();

  useEffect(() => {
    console.log('Auth0BackendLogin state:', { 
      isAuthenticated, 
      loading, 
      hasUser: !!user,
      userEmail: user?.email,
      error 
    });
  }, [isAuthenticated, loading, user, error]);

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Checking authentication...</Typography>
      </Box>
    );
  }

  if (isAuthenticated && user) {
    return (
      <Box className="login-container">
        <Typography variant="h5" gutterBottom>
          Welcome, {user.name || user.email}!
        </Typography>
        <Typography variant="body1" gutterBottom>
          You are successfully logged in.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Email: {user.email}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="login-container">
      <Typography variant="h5" gutterBottom>
        Standard Login
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
        
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="body2">
            <strong>Authentication Error:</strong> {error}
          </Typography>
        </Alert>
      )}
      
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          console.log('Initiating backend Auth0 login...');
          login();
        }}
        sx={{ mt: 2 }}
      >
        Login
      </Button>
      
      <Typography variant="caption" display="block" sx={{ mt: 2, color: 'text.secondary' }}>
        You will be redirected to our secure authentication service
      </Typography>
    </Box>
  );
};

export default Auth0BackendLogin;
